import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, Settings } from "lucide-react";
import { useCart } from "@/contexts/CartContext";
import { Button } from "@/components/ui/button";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_food-cart-pro-3/artifacts/qa8o24lz_06B904DE-5CF2-4C4D-9FF1-6DCC2AB7D252.png";

export default function Navbar({ showCartButton = true }) {
  const { count, setOpen } = useCart();
  const navigate = useNavigate();

  return (
    <header className="glass-nav sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-3 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-3">
          <img src={LOGO_URL} alt="White River Energy" className="h-14 w-14 object-contain" />
          <span className="hidden sm:block font-display text-lg tracking-tight leading-tight">
            White River <span className="text-primary">Energy</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm tracking-wide">
          <a href="/#specials" data-testid="nav-specials" className="hover:text-primary transition-colors">Specials</a>
          <a href="/#build" data-testid="nav-build" className="hover:text-primary transition-colors">Build Your Own</a>
          <a href="/#visit" data-testid="nav-visit" className="hover:text-primary transition-colors">Visit</a>
        </nav>

        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate("/admin/login")}
            data-testid="admin-link-btn"
            className="rounded-full"
            title="Admin"
          >
            <Settings className="h-4 w-4" strokeWidth={1.5} />
          </Button>
          {showCartButton && (
            <Button
              onClick={() => setOpen(true)}
              data-testid="open-cart-btn"
              className="rounded-full bg-primary hover:bg-primary/90 text-primary-foreground gap-2 px-5"
            >
              <ShoppingBag className="h-4 w-4" strokeWidth={1.5} />
              <span data-testid="cart-count" className="text-sm font-medium">{count}</span>
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}
